import React, { Component } from "react";
import logo from "../../assets/img/logo/logo-stacked.png";
import { CopyrightWrapper } from "./style.js";

/**
 * Displays copyright line with small, stacked SRH Logo
 */
export default class SRHCopyright extends Component {
  render() {
    const currentYear = new Date().getFullYear();
    return (
      <CopyrightWrapper>
        <p className={this.props.textClass}>
          © {currentYear} - Confidential Work Product - Do not distribute or reproduce without permission -
          safeandreliablecare.com
        </p>
        {!this.props.noImage && <img alt="Safe &amp; Reliable Healthcare logo" src={logo} className={this.props.smallLogo ? "small" : ""}/>}
      </CopyrightWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SRHCopyright/index.jsx